import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customerror403',
  templateUrl: './customerror403.component.html',
  styleUrls: ['./customerror403.component.scss']
})
export class Customerror403Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
